<div class="site">
  @if (loading) {
    <app-loader class="global-loader" [loading]="loading" [config]="loading_config" [progress]="progress" />
  }
  <div class="outlet">
    <router-outlet />
  </div>
  <!-- <app-footer *ngIf="!loading"></app-footer> -->
</div>